import { render, staticRenderFns } from "./Cafes.vue?vue&type=template&id=2aad8f05&scoped=true&"
import script from "./Cafes.vue?vue&type=script&lang=js&"
export * from "./Cafes.vue?vue&type=script&lang=js&"
import style0 from "./Cafes.vue?vue&type=style&index=0&id=2aad8f05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aad8f05",
  null
  
)

export default component.exports